// Types pour le système de jeu

export interface Vector2 {
  x: number;
  y: number;
}

export interface MapConfig {
  id: string;
  name: string;
  width: number;
  height: number;
  playerStart: { x: number; y: number };
  data: number[]; // Format ancien (compatibilité)
}

export interface MapData {
  w: number;
  h: number;
  tiles: number[];
  playerSpawn: {
    x: number;
    y: number;
    a: number; // angle en radians
  };
  entities?: Entity[];
  triggers?: Trigger[];
}

export interface Entity {
  type: 'enemy' | 'item' | 'ammo' | 'health';
  x: number;
  y: number;
  variant?: string;
  hp?: number;
  active?: boolean;
}

export interface Enemy {
  x: number;
  y: number;
  speed: number;
  alive: boolean;
  hp?: number;
  isBoss?: boolean;
  path?: Vector2[] | null;
  pathIndex?: number;
  nextPathTimer?: number;
}

export interface Trigger {
  type: 'door' | 'switch' | 'zone';
  x: number;
  y: number;
  id: string;
}

export interface Player {
  x: number;
  y: number;
  dirX: number;
  dirY: number;
  planeX: number;
  planeY: number;
  angle: number; // Angle de rotation en radians
  health: number;
  hp: number; // Points de vie actuels
  maxHp: number; // Points de vie maximum
  baseSpeed: number;
  moveSpeed: number; // Vitesse de déplacement
  rotSpeed: number;
}

export interface RayHit {
  distance: number;
  perpWallDist: number;
  wallType: number;
  side: number; // 0 = vertical (NS), 1 = horizontal (EW)
  hitX: number;
  hitY: number;
  wallX: number; // Position exacte sur le mur (pour textures)
}

export interface Weapon {
  name: string;
  damage: number;
  cooldown: number;
  spread: number; // Pour shotgun
  pellets: number; // Nombre de projectiles
  mode: 'semi' | 'auto';
  frames: number[]; // Index de frames d'animation
}

export enum GameState {
  MENU = 'MENU',
  PLAYING = 'PLAYING',
  PAUSED = 'PAUSED',
  GAME_OVER = 'GAME_OVER'
}

export interface DifficultyProfile {
  enemySpeedMul: number;
  waveEnemyMul: number;
  damageTakenMul: number;
}
